<template>
  <div class="agreement-contain">
    <div class="h0-title">一部手机管旅游服务协议</div>
    <div class="content">本协议更新日期2024年11月20日</div>
    <div class="content">本协议生效日期2024年11月27日</div>
    <div class="content">云南腾云信息产业有限公司(下称“我们”)在此特别提醒您（“您”是指注册、登录、使用、浏览本服务的个人或组织，也称“用户”）认真阅读、充分理解本《一部手机管旅游服务协议》(下称 《协议》) —— 您应认真阅读、充分理解本《协议》中各条款，包括免除或者限制我们责任的免责条款及对用户的权利限制条款。请您审慎阅读并选择接受或不接受本《协议》。除非您接受本《协议》所有条款，否则您无权登录或使用本协议所涉相关服务。您的登录、使用等行为将视为对本《协议》的接受，并同意接受本《协议》各项条款的约束。</div>
    <div class="content">我们会在必要时修改本协议，如制订、修改本协议及/或各类规则向您提供基于互联网以及移动网的相关服务的，应在本页面及其相应页面提前公布通知，您应该定期登录本页面及其他相关页面，了解最新的协议内容。变更后的协议和规则在本页面及相关页面公布后七天自动生效。如您不同意相关变更，应当立即停止使用我们提供的服务，若您在网站协议和规则变更七日后继续使用我们提供的服务，即表示您接受已经修订的协议和规则。</div>
    <div class="content">一、协议的范围</div>

    <div class="content">1.1协议适用主体范围</div>
    <div class="content">本协议是用户与我们之间关于用户下载、安装、使用一部手机管旅游软件(下称"一机管") ，以及使用我们相关服务所订立的协议。</div>

    <div class="content">1.2本协议内容同时包括我们可能不定期更新、发布的关于本服务的相关协议、业务规则等内容。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。</div>

    <div class="content">二、关于本服务</div>

    <div class="content">2.1本服务的内容</div>

    <div class="content">本服务内容是指我们向您提供的跨平台监管服务，支持处置云南省范围内游客通过“一部手机游云南”平台等发起的投诉、退货申请；管理云南省范围内的导游和旅行社业态，实现对导游带团轨迹和旅行社经营行为的在线动态监管；在全省范围内对涉旅企业开展诚信指数评价工作，实现对涉旅企业的实时监管；同时为您提供包括但不限于关系链拓展、人工智能等功能或内容的软件使用许可及服务(下称“本服务")。</div>

    <div class="content">2.2本服务的形式</div>

    <div class="content">本服务中一机管提供包括但不限于iOS、Android客户端及网页版等多个应用版本，您必须选择与所安装终端设备相匹配的软件版本。</div>

    <div class="content">2.3本服务许可的范围</div>

    <div class="content">2.3.1我们给予您个人的、不可转让及非排他性的一项许可，以使用一机管。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行一机管。</div>

    <div class="content">2.3.2本条及本协议其他条款未明示授权的其他一切权利仍由我们保留，您在行使这些权利时须另外取得我们的书面许可。我们如果未行使前述任何权利，并不构成对该权利的放弃。</div>

    <div class="content">三、软件的获取</div>

    <div class="content">3.1您可以直接从我们获取一机管，也可以从得到我们授权的第三方获取。</div>

    <div class="content"><span class="weight-big">3.2如果您从未经我们授权的第三方获取一机管或与一机管名称相同的安装程序，我们无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。</span></div>

    <div class="content">四、软件的安装与卸载</div>

    <div class="content"><span class="weight-big">4.1我们可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。</span></div>

    <div class="content">4.2下载安装程序后，您需要按照该程序提示的步骤正确安装。</div>

    <div class="content">4.3为提供更加优质、安全的服务,在一机管安装时我们可能推荐您安装其他软件，您可以选择安装或不安装。</div>

    <div class="content">4.4如果您不再需要使用一机管或者需要安装新版软件，可以自行卸载。如果您愿意帮助我们改进产品服务，请告知卸载的原因。</div>

    <div class="content">五、软件的更新</div>

    <div class="content">5.1为了改善用户体验、完善服务内容，我们将不断努力开发新的服务，并为您不时提供软件更新(这些更新可能会采取软件替换、修改、功能强化、版本升级等形式)。</div>

    <div class="content">5.2为了保证一机管及服务的安全性和功能的一致性，我们有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</div>

    <div class="content">5.3一机管新版本发布后，旧版本的软件可能无法使用。我们不保证旧版一机管继续可用及相应的客户服务，请您随时核对并下载最新版本。</div>

    <div class="content">六、用户个人信息保护</div>

    <div class="content">6.1保护用户个人信息是我们的一项基本原则，我们将会采取合理的措施保护您的个人信息。除法律法规规定的情形外，未经您许可我们不会向第三方公开、透露您个人信息。我们对相关信息采用专业加密存储与传输方式，保障您个人信息的安全。</div>
    <div class="content">6.2您在注册账号或使用本服务的过程中，需要提供一些必要的信息，例如：为向您提供账号注册服务或进行用户身份识别，需要您填写手机号码等。若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</div>

    <div class="content">6.3一般情况下，您可随时浏览、修改自己提交的个人信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的初始注册信息及其他验证信息。</div>

    <div class="content">6.4我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</div>

    <div class="content">6.5未经您的同意，我们不会向我们以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</div>

    <div class="content">七、主权利义务条款</div>

    <div class="content">7.1账号使用规范</div>

    <div class="content">7.1.1您在使用本服务前需提前联系我们工作人员或州市管理员创建账号。我们有权根据用户需求或产品需要对账号注册和绑定的方式进行变更。</div>

    <div class="content">7.1.2一机管账号的所有权归我们所有，您完成申请注册手续后，仅获得一机管账号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得赠予、借用、租用、转让或售卖一机管账号或者以其他方式许可非初始申请注册人使用一机管账号。非初始申请注册人不得通过受赠、继承、承租、受让或者其他任何方式使用一机管账号。</div>

    <div class="content"><span class="weight-big">7.1.3 您有责任妥善保管注册账户信息及账户密码的安全，您需要对注册账户以及密码下的行为承担法律责任。您同意在任何情况下不向他人透露账户及密码信息。当您怀疑他人在使用您的账号时，您应立即通知我们。</span></div>

    <div class="content">7.1.4您注册一机管账号后如果长期（长期指：一年及以上）不登录该账号，我们有权暂时关闭该账号使用权限，以免造成资源浪费，由此带来的任何损失均由您自行承担。</div>

    <div class="content">7.2用户注意事项</div>

    <div class="content">7.2.1您理解并同意：为了向您提供有效的服务，一机管会利用您终端设备的处理器和带宽等资源。一机管使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息，并自行承担相关费用。</div>

    <div class="content">7.2.2您在使用一机管某一特定服务时，该服务可能会另有单独的协议、相关业务规则等(以下统称为“单独协议”)，您在使用该项服务前请阅读并同意相关的单独协议；您使用前述特定服务，即视为您接受相关单独协议。</div>

    <div class="content"><span class="weight-big">7.2.3您理解并同意我们将会尽其服务上的合理努力保障您在一机管及服务中的数据存储安全,但是，我们并不能就此提供完全保证，包括但不限于以下情形：</span></div>

    <div class="content"><span class="weight-big">7.2.3.1 我们不对您在一机管及服务中相关数据的删除或储存失败负责；</span></div>

    <div class="content"><span class="weight-big">7.2.3.2我们有权根据实际情况自行决定单个用户在一机管及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。您可根据自己的需要自行备份一机管及服务中的相关数据；</span></div>

    <div class="content"><span class="weight-big">7.2.3.3 如果您停止使用一机管及服务或服务被终止或取消，我们可以从服务器上永久地删除您的数据。</span></div>

    <div class="content"><span class="weight-big">7.2.4您在使用一机管及服务时，须自行承担如下来自我们不可掌控的风险内容，包括但不限于：</span></div>

    <div class="content"><span class="weight-big">7.2.4.1 由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；</span></div>

    <div class="content"><span class="weight-big">7.2.4.2 您必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由您自行承担；</span></div>

    <div class="content"><span class="weight-big">7.2.4.3 您在使用一机管访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由您自行承担；</span></div>

    <div class="content"><span class="weight-big">7.2.4.4 您发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；</span></div>

    <div class="content"><span class="weight-big">7.2.4.5由于无线网络信号不稳定、无线网络带宽小等原因，所引起的账号登录失败、资料同步不完整、页面打开速度慢等风险。</span></div>

    <div class="content">7.3第三方产品和服务</div>

    <div class="content">7.3.1您在使用一机管第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。我们和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。</div>

    <div class="content">7.3.2因您使用一机管或要求我们提供特定服务时，一机管可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问的结果由该第三方提供(包括但不限于第三方通过一机管公众账号提供的服务，或通过开放平台接入的内容等)， 我们不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与我们无关，我们不承担任何责任。</div>

    <div class="content">7.3.3您理解并同意，我们有权决定将一机管作商业用途，包括但不限于开发、使用一机管的部分服务为第三方做推广等，我们承诺在推广过程中严格按照本协议约定保护您的个人信息。</div>

    <div class="content">八、用户行为规范</div>

    <div class="content">8.1信息内容规范</div>

    <div class="content">8.1.1 本条所述信息内容是指您使用一机管及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于一机管账号头像、名字等注册信息，或文字、语音、图片等发送、回复、相关链接页面，以及其他使用一机管账号或一机管及服务所产生的内容。</div>

    <div class="content"><span class="weight-big">8.1.2您理解并同意，我们一直致力于为您提供文明健康、规范有序的网络环境，您不得利用一机管账号或一机管及服务制作、复制、发布、传播如下干扰一机管正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：</span></div>

    <div class="content"><span class="weight-big">8.1.2.1 发布、传送、传播、储存违反国家法律法规禁止的内容：</span></div>

    <div class="content"><span class="weight-big">(1)违反宪法确定的基本原则的；</span></div>
    <div class="content"><span class="weight-big">(2)危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</span>
    </div><div class="content"><span class="weight-big">(3)损害国家荣誉和利益的；</span></div>
    <div class="content"><span class="weight-big">(4)煽动民族仇恨、民族歧视，破坏民族团结的；</span></div>
    <div class="content"><span class="weight-big">(5)破坏国家宗教政策，宣扬邪教和封建迷信的；</span></div>
    <div class="content"><span class="weight-big">(6)散布谣言，扰乱社会秩序，破坏社会稳定的；</span></div>
    <div class="content"><span class="weight-big">(7)散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</span></div>
    <div class="content"><span class="weight-big">(8)侮辱或者诽谤他人，侵害他人合法权益的；</span></div>
    <div class="content"><span class="weight-big">(9)煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</span></div>
    <div class="content"><span class="weight-big">(10)以非法民间组织名义活动的；</span></div>
    <div class="content"><span class="weight-big">(11)不符合遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；</span></div>
    <div class="content"><span class="weight-big">(12)含有法律、行政法规禁止的其他内容的。</span></div>

    <div class="content"><span class="weight-big">8.1.2.2发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</span></div>

    <div class="content"><span class="weight-big">8.1.2.3 涉及他人隐私、个人信息或资料的；</span></div>

    <div class="content"><span class="weight-big">8.1.2.4发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；</span></div>

    <div class="content"><span class="weight-big">8.1.2.5其他违反法律法规、政策及公序良俗、社会公德或干扰一机管正常运营和侵犯其他用户或第三方合法权益内容的信息。</span></div>

    <div class="content"><span class="weight-big">8.2软件使用规范</span></div>

    <div class="content"><span class="weight-big">8.2.1除非法律允许或我们书面许可，您使用一机管过程中不得从事下列行为：</span></div>

    <div class="content"><span class="weight-big">8.2.1.1 删除一机管及其副本上关于著作权的信息；</span></div>

    <div class="content"><span class="weight-big">8.2.1.2 对一机管进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现一机管的源代码；</span></div>

    <div class="content"><span class="weight-big">8.2.1.3 对我们拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</span></div>

    <div class="content"><span class="weight-big">8.2.1.4 对一机管或者一机管运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及一机管运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非我们经授权的第三方工具/服务接入一机管和相关系统；</span></div>

    <div class="content"><span class="weight-big">8.2.1.5通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</span></div>

    <div class="content"><span class="weight-big">8.2.1.6通过非我们开发、授权的第三方软件、插件、外挂、系统，登录或使用我们软件及服务，或制作、发布、传播上述工具；</span></div>

    <div class="content"><span class="weight-big">8.2.1.7 自行或者授权他人、第三方软件对一机管及其组件、模块、数据进行干扰；</span></div>

    <div class="content"><span class="weight-big">8.2.1.8 其他未经我们明示授权的行为。</span></div>

    <div class="content">8.2.2您理解并同意，基于您体验、一机管或相关服务平台运营安全、平台规则要求及健康发展等综合因素，我们有权选择提供服务的对象，有权决定功能设置，有权决定功能开放、数据接口和相关数据披露的对象和范围。针对以下情形，有权视具体情况中止或终止提供本服务，包括但不限于：</div>

    <div class="content">8.2.2.1违反法律法规或本协议规定的；</div>

    <div class="content">8.2.2.2影响服务体验的；</div>

    <div class="content">8.2.2.3存在安全隐患的；</div>

    <div class="content">8.2.2.4与一机管或其服务平台已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；</div>

    <div class="content">8.2.2.5 界面、风格、功能、描述或使用者体验与一机管或其服务平台类似，可能造成一机管用户认为其所使用的功能或服务来源于我们或经我们授权的；</div>

    <div class="content">8.2.2.6 违背一机管或其服务平台运营原则，或不符合我们其他管理要求的。</div>

    <div class="content">8.3对自己行为负责</div>

    <div class="content"><span class="weight-big">您充分了解并同意，您必须为自己注册和使用账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。我们无法且不会对因前述风险而导致的任何损失或损害承担责任。</span></div>

    <div class="content">8.4违约处理</div>

    <div class="content"><span class="weight-big">8.4.1如果我们发现或收到他人举报或投诉用户违反本协议约定的，我们有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用部分或全部功能、账号封禁直至注销的处罚，并公告处理结果。</span></div>

    <div class="content">8.4.2您理解并同意，我们有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。</div>

    <div class="content">8.4.3您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；我们因此遭受损失的，您也应当一并赔偿。</div>

    <div class="content">九、知识产权声明</div>

    <div class="content">9.1我们是一机管的知识产权权利人。一机管的一切著作权、商标权、专利权、商业秘密等知识产权，以及与一机管相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，我们享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。</div>

    <div class="content">9.2未经我们或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</div>

    <div class="content">9.3您接受本协议条款，即表明您将在一机管发表的任何形式的信息的著作权，包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利无偿独家转让给我们所有，同时表明您许可我们有权利就任何主体侵权而单独提起诉讼，并获得全部赔偿。</div>

    <div class="content">9.4协议已经构成《中华人民共和国著作权法》第二十五条所规定的书面协议，其效力及于您在我们发布的任何受著作权法保护的作品内容，无论该内容形成于本协议签订前还是本协议签订后。您同意并明确了解上述条款，不将已发表于一机管的信息，以任何形式发布或授权其它网站及媒体（我们关联公司网站除外）使用。同时，我们保留删除站内各类不符合规定的信息而不通知您的权利。</div>

    <div class="content">9.5一机管所有信息受《中华人民共和国著作权法》及相关法律法规和中国加入的所有知识产权方面的国际条约的保护。我们制定了旨在保护知识产权权利人合法权益的相关措施和步骤，当著作权人和或依法可以行使信息网络传播权的权利人（以下简称"权利人”）发现可能存有侵犯其信息网络传播权的情况，权利人应事先向一机管发出书面权利通知，并提供有效权属证明，我们将根据相关法律规定采取措施删除相关内容。同时您登录一机管提交相关评论、文章或其他信息通过我们编辑发布的，我们享有著作权，我们有权在本网站及关联公司网站使用您在一机管上发布的信息（包括但不限于图片、游记等），但您在一机管上发布的信息若其它浏览者要转载，需经过我们和您的许可，否则视为侵权，其他任何第三人未经我们允许，不得以任何形式复制、转载或采用。因您或其他第三人违反本法律声明而引发的任何一切索赔、损害等等，我们概不负责。</div>
    <div class="content">9.6我们不保证为向您提供便利而设置的外部链接的准确性和完整性，若由此而引起的版权问题或其他问题，请致电或电邮我们。经核实后会立即予以删除或更改。</div>

    <div class="content">十、终端安全责任</div>

    <div class="content">10.1您理解并同意，一机管同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响一机管的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。</div>

    <div class="content">10.2您不得制作、发布、使用、传播用于窃取一机管账号及他人个人信息、财产的恶意程序。</div>

    <div class="content">10.3维护软件安全与正常使用是我们和您的共同责任，我们将按照行业标准合理审慎地采取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意我们并不能就此提供完全保证。</div>

    <div class="content">10.4在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意我们有关防范诈骗犯罪的提示。</div>

    <div class="content">十一、第三方软件或技术</div>

    <div class="content">11.1一机管可能会使用第三方软件或技术（包括一机管可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。</div>

    <div class="content">11.2一机管如果使用了第三方的软件或技术，我们将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在一机管安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。<span class="weight-big">如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求我们给予协助，您应当自行承担法律责任。</span></div>

    <div class="content"><span class="weight-big">11.3如因一机管使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，我们不承担任何责任。我们不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。</span></div>

    <div class="content">十二、其他</div>

    <div class="content">12.1我们公司郑重提醒您注意本《协议》中免除我们公司责任和加重您义务的条款，请您仔细阅读，自主考虑风险。</div>

    <div class="content">12.2本《协议》所规定的任何条款的部分或全部无效者，不影响其它条款的效力。</div>

    <div class="content">12.3本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</div>

    <div class="content"><span class="weight-big">12.4本《协议》签订地为人民共和国云南省昆明市西山区。本《协议》的解释、效力及纠纷的解决，适用于中华人民共和国法律大陆地区法律（不包括冲突法）。若您和我们之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</span></div>

    <div class="content">12.5本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</div>

    <div class="content">12.6若您对我们及本服务协议有任何意见，欢迎垂询我们客服中心（客户服务热线: 400-88-96301）或联系以下地址：云南省昆明市西山区环城南路777号昆钢科技大厦6F。（正文完）</div>

  </div>
</template>

<script>
    export default {
        components: {},
        data () {
            return {
                list: [],
                authData: {}
            };
        },
        computed: {},
        watch: {},
        methods: {},
        mounted () {
            document.title = '服务协议'
        },

        created () {},
        beforeCreate () {
            document.title = '服务协议'
        }
    };
</script>

<style scoped lang="less">
.agreement-contain{
  padding: 0 12px 20px;
  .weight-big{
    font-weight: 700!important;
  }
  .h0-title{
    font-size:16px;
    font-family:PingFangSC-Semibold,Arial,sans-serif;
    -webkit-font-smoothing: antialiased;
    font-weight:700;
    color:rgba(51,51,51,1);
    line-height:14px;
    margin-top: 24px;
  }
  .content{
    font-size:14px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:22px;
    margin-top: 12px;
  }
  .content-box{
    .h1-title{
      font-size:14px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(51,51,51,1);
      line-height:14px;
      margin-top: 16px;
    }
    .h1-box{
      .h2-title{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
        margin-top: 12px;
      }
      .h2-content{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(102,102,102,1);
        line-height:22px;
        margin-top: 12px;
      }
    }
  }
}
</style>
